import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { SocialMediaGetAllService } from '../../services';

export const fetchSocialMediaGetAll = createAsyncThunk(
    'socialMediaGetAll/fetchSocialMediaGetAll',
    async () => {
        const response = await SocialMediaGetAllService()
        return response.result
    }
);

const socialMediaGetAllSlice = createSlice({
    name: 'socialMediaGetAll',
    initialState: {
        data: null,
        status: 'idle',
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchSocialMediaGetAll.pending, (state) => {
                state.status = 'loading';
            })
            .addCase(fetchSocialMediaGetAll.fulfilled, (state, action) => {
                state.status = 'succeeded';
                state.data = action.payload;
            })
            .addCase(fetchSocialMediaGetAll.rejected, (state) => {
                state.status = 'failed';
            });
    },
});

export default socialMediaGetAllSlice.reducer;
